<template>
  <svg :width="width" :height="height" viewBox="0 0 19 18" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="" fill-opacity="0.3"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 19},
    height: { type: [Number, String], default: 18},
    color: { type: String, default: colors.iconArinet}
  }
}
</script>